import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from "react";
import { useQuery } from "react-query";
import { getMeasureDetailModel } from "@webapi/api";
import { isEmptyObject, isNotEmptyArray } from "utils/validation";
import { dateConvertKeys } from "utils/dates";
import { useErrorNotifications } from "@notifications/errorNotifications";
import { useAuthContext } from "@authentication/context";
export var useMeasureDetail = function useMeasureDetail(params) {
  var _useAuthContext = useAuthContext(),
    getUser = _useAuthContext.getUser;
  var authTicket = getUser().ticket;
  var queryFunc = function queryFunc() {
    return getMeasureDetailModel(params, authTicket);
  };
  var _useQuery = useQuery(["measureDetail", params.parentMeasure, authTicket], queryFunc, {
      initialData: {},
      enabled: isNotEmptyArray(params.measureIds)
    }),
    measureDetail = _useQuery.data,
    status = _useQuery.status,
    error = _useQuery.error,
    isError = _useQuery.isError,
    isFetching = _useQuery.isFetching,
    refetch = _useQuery.refetch;
  var notifiableError = ![400, 404].includes(error) && error;
  useErrorNotifications(notifiableError, ". Lyckades inte hämta metadata.");
  var dateConvertedMeasureDetail = useMemo(function () {
    return !isEmptyObject(measureDetail) ? _objectSpread(_objectSpread({}, measureDetail), {}, {
      metadata: dateConvertKeys(["earliestDataDate", "lastDataDate"], measureDetail.metadata)
    }) : {};
  }, [measureDetail]);
  return useMemo(function () {
    return {
      status: status,
      loading: isFetching,
      error: isError,
      errorMessage: error,
      refetchMeasureDetail: refetch,
      measureDetail: dateConvertedMeasureDetail
    };
  }, [isFetching, status, isError, error, dateConvertedMeasureDetail, refetch]);
};